/*
  Comportements d'interface partagés RésineLab : accordéons, onglets, compteurs de quantité.
  JavaScript natif, délégation d'événements : fonctionne aussi sur le contenu rechargé
  par l'API de rendu de section (filtres, panier).
*/
(function () {
  'use strict';

  /* ------------------------------------------------------------ Accordéons */
  // <div data-rl-accordion data-open="false">
  //   <button data-rl-accordion-toggle aria-expanded="false">…</button>
  //   <div>…</div>
  // </div>
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-rl-accordion-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-rl-accordion]');
    if (!wrap) return;
    var open = wrap.getAttribute('data-open') === 'true';
    wrap.setAttribute('data-open', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  /* --------------------------------------------------------------- Onglets */
  // <div data-rl-tabs>
  //   <button data-rl-tab="id" aria-selected="true">…</button>
  //   <div data-rl-panel="id">…</div>
  // </div>
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-rl-tab]');
    if (!tab) return;
    var wrap = tab.closest('[data-rl-tabs]');
    if (!wrap) return;
    var id = tab.getAttribute('data-rl-tab');

    Array.prototype.forEach.call(wrap.querySelectorAll('[data-rl-tab]'), function (el) {
      el.setAttribute('aria-selected', el === tab ? 'true' : 'false');
      // Focus itinérant : seul l'onglet actif est dans l'ordre de tabulation (flèches pour les autres)
      if (el.getAttribute('role') === 'tab') el.setAttribute('tabindex', el === tab ? '0' : '-1');
    });
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-rl-panel]'), function (panel) {
      panel.hidden = panel.getAttribute('data-rl-panel') !== id;
    });
  });

  // Navigation clavier entre onglets (flèches gauche/droite)
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    var tab = event.target.closest('[data-rl-tab]');
    if (!tab) return;
    var wrap = tab.closest('[data-rl-tabs]');
    if (!wrap) return;
    var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[data-rl-tab]'));
    var next = tabs[tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1)];
    if (!next) return;
    event.preventDefault();
    next.focus();
    next.click();
  });

  /* ---------------------------------------------------- Compteurs quantité */
  // <div class="rl-qty" data-rl-qty>
  //   <button data-rl-qty-step="-1">−</button><input type="number" value="1"><button data-rl-qty-step="1">+</button>
  // </div>
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-rl-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-rl-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;

    var min = parseInt(input.getAttribute('min') || '1', 10);
    var max = parseInt(input.getAttribute('max') || '0', 10);
    var value = parseInt(input.value || min, 10) + parseInt(step.getAttribute('data-rl-qty-step'), 10);

    if (isNaN(value) || value < min) value = min;
    if (max > 0 && value > max) value = max;

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
